(function () {
  var root = document.getElementById('cma');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  var intro = root.querySelector('[data-cma-intro]');
  var cards = root.querySelector('[data-cma-cards]');
  var answer = root.querySelector('[data-cma-answer]');
  var formWrap = root.querySelector('[data-cma-formwrap]');
  var panels = root.querySelectorAll('.cma-panel');
  var form = document.getElementById('cma-form');
  var reasonInput = root.querySelector('[data-cma-reason]');
  var reasonLabel = root.querySelector('[data-cma-reason-label]');
  var order = root.querySelector('[data-cma-order]');
  var noOrder = root.querySelector('[data-cma-noorder]');
  var trackBtn = root.querySelector('.cma-panel[data-case="track"] a.cma-btn');
  var accountUrl = trackBtn ? trackBtn.getAttribute('href') : '/account';
  var FAQ = '/pages/faq';

  function scrollToEl(el) {
    var top = el.getBoundingClientRect().top + window.pageYOffset - 90;
    window.scrollTo({ top: top, behavior: 'smooth' });
  }

  function choose() {
    intro.hidden = false;
    cards.hidden = false;
    answer.hidden = true;
    panels.forEach(function (p) { p.hidden = true; });
    if (formWrap) formWrap.hidden = true;
    root.dataset.state = 'choose';
    scrollToEl(root);
  }

  function openForm(panel) {
    if (!form || !formWrap) return;
    var reason = panel.getAttribute('data-reason') || 'Autre demande';
    var extra = panel.getAttribute('data-extra');
    if (reasonInput) reasonInput.value = reason;
    if (reasonLabel) reasonLabel.textContent = reason;
    form.querySelectorAll('[data-extra-group]').forEach(function (g) {
      var on = extra && g.getAttribute('data-extra-group') === extra;
      g.hidden = !on;
      g.querySelectorAll('input').forEach(function (i) { i.disabled = !on; });
    });
    formWrap.hidden = false;
    var wrote = panel.querySelector('[data-write]');
    if (wrote && wrote.closest('.cma-help')) wrote.closest('.cma-help').hidden = true;
    panel.after(formWrap);
    scrollToEl(formWrap);
    var first = formWrap.querySelector('input[name="contact[Prénom]"]');
    if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 400);
  }

  function open(id) {
    var target = root.querySelector('.cma-panel[data-case="' + id + '"]');
    if (!target) return;
    intro.hidden = true;
    cards.hidden = true;
    answer.hidden = false;
    panels.forEach(function (p) {
      p.hidden = p !== target;
      var h = p.querySelector('.cma-help');
      if (h) h.hidden = false;
    });
    if (formWrap) formWrap.hidden = true;
    root.dataset.state = 'answer';
    if (target.hasAttribute('data-direct')) {
      openForm(target);
    } else {
      scrollToEl(root);
    }
  }

  function businessDays(from, to) {
    var d = new Date(from.getFullYear(), from.getMonth(), from.getDate());
    var end = new Date(to.getFullYear(), to.getMonth(), to.getDate());
    var n = 0;
    while (d < end) {
      d.setDate(d.getDate() + 1);
      var w = d.getDay();
      if (w !== 0 && w !== 6) n++;
    }
    return n;
  }

  function resultBox(panel, html) {
    var out = panel.querySelector('[data-cma-delay-result]');
    out.innerHTML = html;
    out.hidden = false;
    return out;
  }

  function formatDate(d) {
    return ('0' + d.getDate()).slice(-2) + '/' + ('0' + (d.getMonth() + 1)).slice(-2) + '/' + d.getFullYear();
  }

  function elapsed(days) {
    return days > 1 ? days + ' jours ouvrés se sont écoulés' : days + ' jour ouvré s\'est écoulé';
  }

  function runDelayCheck(panel) {
    var dateEl = panel.querySelector('[data-cma-delay-date]');
    var countryEl = panel.querySelector('[data-cma-delay-country]');
    var preEl = panel.querySelector('[data-cma-delay-pre]');
    if (formWrap) formWrap.hidden = true;
    panel.removeAttribute('data-extra');

    if (preEl.checked) {
      resultBox(panel,
        '<p><strong>Une précommande est expédiée à la date indiquée sur sa fiche produit.</strong> Les délais de livraison démarrent à partir de cette date, et non de la date de commande. Rien d\'inquiétant : votre commande patiente simplement en coulisses.</p>' +
        '<div class="cma-actions"><a class="cma-btn" href="' + FAQ + '#precommandes">Voir le fonctionnement des précommandes</a></div>');
      return;
    }
    if (!dateEl.value) {
      resultBox(panel, '<p>Indiquez la date de votre commande pour que nous puissions vérifier les délais.</p>');
      return;
    }
    var ordered = new Date(dateEl.value + 'T00:00:00');
    var today = new Date();
    if (isNaN(ordered.getTime()) || ordered > today) {
      resultBox(panel, '<p>La date de commande semble incorrecte. Vérifiez-la et réessayez.</p>');
      return;
    }
    var isFrance = countryEl.value === 'fr';
    var limit = isFrance ? 7 : 12;
    var days = businessDays(ordered, today);

    if (days <= limit) {
      resultBox(panel,
        '<p><strong>Votre commande est encore dans les délais habituels.</strong> ' + elapsed(days) +
        ' depuis votre commande, pour un délai habituel de ' + limit + ' jours ouvrés maximum ' + (isFrance ? 'en France métropolitaine' : 'pour les autres pays') +
        ' (préparation et livraison comprises). Suivez votre colis, et si rien n\'est arrivé passé ce délai, revenez ici.</p>' +
        '<div class="cma-actions"><a class="cma-btn" href="' + accountUrl + '">Suivre ma commande</a>' +
        '<a class="cma-link" href="' + FAQ + '#delais-livraison">Consulter la FAQ livraison</a></div>');
      return;
    }

    resultBox(panel,
      '<p><strong>Votre commande dépasse le délai habituel.</strong> ' + elapsed(days) + ' depuis votre commande, pour un délai habituel de ' + limit +
      ' jours ouvrés maximum. Renseignez le formulaire ci-dessous : votre message nous parvient directement.</p>');
    var outDate = form.querySelector('[data-cma-delay-out-date]');
    var outCountry = form.querySelector('[data-cma-delay-out-country]');
    if (outDate) outDate.value = formatDate(ordered);
    if (outCountry) outCountry.value = isFrance ? 'France métropolitaine' : 'Autre pays';
    panel.setAttribute('data-extra', 'delay');
    panel.setAttribute('data-reason', 'Commande non reçue, délai dépassé');
    openForm(panel);
  }

  root.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open]');
    if (opener) { open(opener.getAttribute('data-open')); return; }
    if (e.target.closest('[data-cma-back]')) { choose(); return; }
    var chk = e.target.closest('[data-cma-delay-check]');
    if (chk) { runDelayCheck(chk.closest('.cma-panel')); return; }
    var write = e.target.closest('[data-write]');
    if (write) {
      var panel = write.closest('.cma-panel');
      if (panel) openForm(panel);
    }
  });

  root.querySelectorAll('[data-cma-extra]').forEach(function (i) { i.disabled = true; });

  if (noOrder && order) {
    noOrder.addEventListener('change', function () {
      order.disabled = noOrder.checked;
      if (noOrder.checked) order.value = '';
    });
  }

  if (form) {
    form.addEventListener('submit', function () {
      var fn = form.querySelector('[name="contact[Prénom]"]');
      var ln = form.querySelector('[name="contact[Nom]"]');
      var full = form.querySelector('[data-cma-fullname]');
      if (full && fn && ln) full.value = (fn.value + ' ' + ln.value).trim();
      if (noOrder && noOrder.checked && order) {
        order.disabled = false;
        order.value = 'Pas de numéro de commande';
      }
    });
  }

  if (root.querySelector('[data-cma-success]')) {
    intro.hidden = true;
    cards.hidden = true;
    formWrap.hidden = false;
    scrollToEl(root);
  } else if (root.querySelector('[data-cma-errors]')) {
    open('other');
  }
})();